import * as React from "react";

import { Button, Grid, Table, InputOnChangeData, Input } from "semantic-ui-react";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { ApplicationState } from "../../../applicationState";

import { adminUsersSelector } from "../selectors";
import { ADMIN_ROLES, Authorize } from "../../../auth";
import { getUserDisplayName } from "../model";

import { loadAdminUsers } from "../actions";

import { Link, replace } from "redux-little-router";

export const All: React.FunctionComponent = () =>
{
    const dispatch = useDispatch();
    const path = useSelector((state: ApplicationState) => state.router.pathname);
    const query = useSelector((state: ApplicationState) => state.router.query);
    const adminUsers = useSelector(adminUsersSelector);
    const [fullName, setFullName] = React.useState("");

    const onFilterValueChange = React.useCallback((event: any, { value }: InputOnChangeData) => {
        setFullName(value);
        dispatch(replace("?fullName=" + `${value}`));
    }, [dispatch]);

    React.useEffect(() => {
        // Reload admin users when the user types in the search box
        if (query) {
            dispatch(loadAdminUsers());
        }
    }, [dispatch, query]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={14}>
                    <h1>Admin Users</h1>
                </Grid.Column>
                <Authorize roles={[ADMIN_ROLES.SYSTEM_ADMIN]}>
                    <Grid.Column width={2} textAlign="right">
                        <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                    </Grid.Column>
                </Authorize>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Email Address</Table.HeaderCell>
                                <Table.HeaderCell>Locum User</Table.HeaderCell>
                                <Table.HeaderCell>Details</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell colSpan="4">
                                    <Input
                                        value={fullName}
                                        onChange={onFilterValueChange}
                                        icon="search"
                                        placeholder="Search..."
                                        size="mini"
                                    />
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {adminUsers.map(adminUser => (
                                <Table.Row key={adminUser.id}>
                                    <Table.Cell>
                                        <Link href={`${path}/${adminUser.id}`}>
                                            {getUserDisplayName(adminUser, true, true)}
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell>
                                        {adminUser.emailAddress}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {adminUser.isLocumUser ? "Yes" : "No"}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Link href={`${path}/${adminUser.id}`}>
                                            <Button key={adminUser.id}>View</Button>
                                        </Link>
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
